import {
  Grid,
  Button,
  Divider,
  Typography,
  IconButton,
  CircularProgress,
  LinearProgress,
} from "@material-ui/core";
import HeaderMenu from "../../../../../Components/HeaderMenu";
import DataClient from "../../../../../Service/general_data_service";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import CancelIcon from "@material-ui/icons/Cancel";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import DataService from "../../../../../Service";
import CloseIcon from "@material-ui/icons/Close";
import { useState } from "react";
import { useSelector } from "react-redux";
import CrfAssignmentCreation from "./CrfAssignmentCreation";
import ManageAccount from "../manage_email";

const CrfDialogHeader = (props) => {
  const {
    crfStatus,
    handleClose,
    loading,
    CoachinRequest,
    getCrfData,
    setLoading,
    empId,
    getCRFList,
  } = props;
  console.log("headerProps", props);
  const dispatch = useDispatch();
  const globaluserData = useSelector((state) => state.commonReducer);

  const [buttonLoading, setButtonLoading] = useState({
    approvalButton: false,
    acknowledgeButton: false,
    cancelButton: false,
  });

  const [assignmentDrawerOpen, setAssignmentDrawerOpen] = useState(false);
  const [createAssignmentData, setCreateAssignmentData] = useState(null);
  const [mailAction, setMailAction] = useState(null);

  const coachingRequestId = CoachinRequest.id;

  const handleAcknowlegment = () => {
    setButtonLoading((prev) => {
      return { ...prev, acknowledgeButton: true };
    });
    const statusData = {
      approval_status: "Acknowledged",
      id: coachingRequestId,
    };
    DataClient.update(statusData, `/crf_users/update_status`)
      .then((res) => {
        if (res?.success) {
          getCrfData();
          getCRFList();
          dispatch(
            showSnackbar(
              "success",
              ["Coaching request acknowledged successfully!"],
              2000
            )
          );
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        dispatch(showSnackbar("error", [["" + err.errors]]));
      })
      .finally(() => {
        setButtonLoading((prev) => {
          return { ...prev, acknowledgeButton: false };
        });
      });
  };

  const handleCancel = () => {
    setButtonLoading((prev) => {
      return { ...prev, cancelButton: true };
    });
    const statusData = {
      approval_status: "Declined",
      id: coachingRequestId,
    };
    DataClient.update(statusData, `/crf_users/update_status`)
      .then((res) => {
        if (res?.success) {
          getCrfData();
          getCRFList();
          dispatch(
            showSnackbar(
              "success",
              ["Coaching request declined successfully!"],
              2000
            )
          );
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        dispatch(showSnackbar("error", [["" + err.errors]]));
      })
      .finally(() => {
        setButtonLoading((prev) => {
          return { ...prev, cancelButton: false };
        });
      });
  };

  const handleCreateAssignment = (e) => {
    setButtonLoading((prev) => {
      return { ...prev, approvalButton: true };
    });

    const formData = new FormData();
    formData.append("crf_id", coachingRequestId);
    formData.append("employee_id", empId === null ? " " : empId);

    DataService.createData(formData, "create_assignment")
      .then((res) => {
        if (res?.success) {
          getCRFList();
          setCreateAssignmentData(res);
          setAssignmentDrawerOpen(true);
        }
      })
      .catch((error) => {
        dispatch(showSnackbar("error", [["" + error.errors]]));
      })
      .finally(() => {
        setButtonLoading((prev) => {
          return { ...prev, approvalButton: false };
        });
      });
  };

  const handleMail = () => {
    setMailAction(true);
  };

  const isApproved =
    crfStatus.approval_Status === "Approved" || assignmentDrawerOpen;
  const isAcknowledged = crfStatus.approval_Status === "Acknowledged";
  const isCancelled = crfStatus.approval_Status === "Decline";

  const isAdmin = globaluserData?.role === "admin";
  return (
    <>
      {" "}
      <HeaderMenu />
      <Grid container style={{ padding: "16px" }} alignItems={"center"}>
        <Grid item xs={4}>
          <Typography
            variant="subtitle1"
            style={{ color: "rgb(99,101,105)" }}
            component={"h6"}
          >
            Coaching request form
          </Typography>
        </Grid>
        <Grid
          item
          xs={7}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "0.5rem",
          }}
        >
          {isAdmin ? (
            loading ? (
              <CircularProgress color="primary" size={30} />
            ) : (
              <>
                <Button
                  disableElevation
                  onClick={handleCreateAssignment}
                  variant={"contained"}
                  disabled={isApproved}
                  color="primary"
                  style={{ textTransform: "initial" }}
                  endIcon={
                    buttonLoading.approvalButton ? (
                      <CircularProgress size={20} color="secondary" />
                    ) : null
                  }
                >
                  {isApproved
                    ? "Assignment approved"
                    : "Approve and create assignment"}
                </Button>

                <Button
                  onClick={handleAcknowlegment}
                  disabled={isAcknowledged}
                  variant={"contained"}
                  color="primary"
                  style={{ textTransform: "initial" }}
                  endIcon={
                    buttonLoading.acknowledgeButton ? (
                      <CircularProgress size={20} color="secondary" />
                    ) : null
                  }
                >
                  {isAcknowledged ? "Acknowledged" : "Acknowledge CRF"}
                </Button>
                <Button
                  disableElevation
                  onClick={handleMail}
                  variant={"contained"}
                  style={{
                    backgroundColor: "#C71C1C",
                    color: "white",
                    textTransform: "initial",
                  }}
                  startIcon={<MailOutlineIcon />}
                >
                  Mail
                </Button>
                <Button
                  disableElevation
                  onClick={handleCancel}
                  disabled={isCancelled}
                  variant={"contained"}
                  style={{ textTransform: "initial" }}
                  startIcon={<CancelIcon />}
                  endIcon={
                    buttonLoading.cancelButton ? (
                      <CircularProgress size={20} color="secondary" />
                    ) : null
                  }
                >
                  {isCancelled ? "Cancelled" : "Cancel CRF"}
                </Button>
              </>
            )
          ) : null}
        </Grid>
        <Grid
          item
          xs={1}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <IconButton
            aria-label="close"
            style={{ padding: 0, color: "#9e9e9e" }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Divider style={{ marginBottom: "8px" }} />
      <CrfAssignmentCreation
        isOpen={assignmentDrawerOpen}
        handleClose={() => {
          setCreateAssignmentData(null);
          setAssignmentDrawerOpen(false);
          getCrfData();
        }}
        createAssignmentData={createAssignmentData}
      />
      {mailAction && (
        <ManageAccount
          {...props}
          open={mailAction}
          onCloseAssignmentModal={() => {
            setMailAction(false);
          }}
        />
      )}
    </>
  );
};

export default CrfDialogHeader;
